import type { IconData } from '@stacksjs/iconify-core'

export const devicesSmartwatch: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 0h8v2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2v2H4v-2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm4 12.25a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesSmartwatch
